interface Satir {
  anahtar: string;
  urunId: string;
  miktar: string;
}

/** Okutma yalnızca ürünü bulur; miktarı kullanıcı elle girer. */
export function transferBarkoduEkle(
  satirlar: Satir[],
  urunId: string,
  anahtar: string,
): Satir[] {
  const hedef = satirlar.findIndex((s) => s.urunId === urunId);
  if (hedef >= 0) return satirlar;
  const bos = satirlar.findIndex((s) => !s.urunId && !s.miktar.trim());
  if (bos >= 0) return satirlar.map((s, i) => i === bos ? { ...s, urunId } : s);
  if (satirlar.length >= 500) throw new Error("Bir transfer en fazla 500 satır içerebilir.");
  return [...satirlar, { anahtar, urunId, miktar: "" }];
}
